import {DocumentPreviewBasePage} from './DocumentPreviewBasePage';
import {DocumentPreviewPageValidationStatus} from './DocumentPreviewPageValidationStatus';
import {DocumentPreviewState} from './DocumentPreviewState';

export interface DocumentPreviewControls {
  setPages: (pages: DocumentPreviewBasePage[]) => void;
  setActiveIndex: (index: number) => void;
  setPageValidation: (pageNumber: number, status: DocumentPreviewPageValidationStatus) => void;
  toggleCollapsed: VoidFunction;
}

export interface UseDocumentPreviewReturnType {
  state: DocumentPreviewState;
  controls: DocumentPreviewControls;
}
